import styled from 'styled-components';

export const OsStyled = styled.div`
  display: flex; 
  .boxHeader {
    padding: 0 0 20px 0;
  }
`;
